// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnTwitter_btn__-dik6","btnTwitter":"BtnTwitter_btnTwitter__2wMHS BtnTwitter_btn__-dik6"};